'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function GuidePage() {
  const { theme } = useTheme()
  const isDark = theme === 'dark'

  const bg = isDark ? '#0f172a' : '#f4f7fb'
  const ink = isDark ? '#e8f0fb' : '#0a1f3a'
  const secondary = isDark ? '#94a3b8' : '#6b7684'
  const card = isDark ? '#1e2a3d' : '#ffffff'
  const border = isDark ? '#2c3a52' : '#e9eff7'
  const accent = isDark ? '#5ea6ff' : '#2b6df0'
  const accentBg = isDark ? 'rgba(43,109,240,0.15)' : '#e9eff7'

  const categories = [
    { name: '입문', href: '/guide/beginner', count: 6 },
    { name: '안전', href: '/safety', count: 5 },
    { name: '장비', href: '/equipment', count: 5 },
    { name: '바다', href: '/map', count: 3 },
  ]

  const guides = [
    { title: '프리다이빙이란?', href: '/guide/what-is-freediving', category: '입문' },
    { title: '자격증 종류', href: '/guide/certifications', category: '입문' },
    { title: '첫 강습 준비물', href: '/guide/first-class-preparation', category: '입문' },
    { title: '강습 비용 안내', href: '/guide/training-cost', category: '입문' },
    { title: '풀다이빙 vs 바다다이빙', href: '/guide/pool-vs-ocean', category: '입문' },
    { title: '호흡법 가이드', href: '/guide/breathing-techniques', category: '입문' },
    { title: '프리다이빙 안전 수칙', href: '/safety/rules', category: '안전' },
    { title: '이퀄라이징 기법', href: '/safety/equalization', category: '안전' },
    { title: '블랙아웃 대처법', href: '/safety/blackout', category: '안전' },
    { title: '응급처치 가이드', href: '/safety/first-aid', category: '안전' },
    { title: '버디 시스템', href: '/safety/buddy-system', category: '안전' },
    { title: '마스크 선택법', href: '/equipment/mask', category: '장비' },
    { title: '스노클 선택 가이드', href: '/equipment/snorkel', category: '장비' },
    { title: '핀 종류와 선택', href: '/equipment/fins', category: '장비' },
    { title: '웨이트벨트 사용법', href: '/equipment/weight-belt', category: '장비' },
    { title: '슈트 가이드', href: '/equipment/wetsuit', category: '장비' },
    { title: '동해안 다이빙 포인트', href: '/map', category: '바다' },
    { title: '서해안 다이빙 포인트', href: '/map', category: '바다' },
    { title: '남해안 다이빙 포인트', href: '/map', category: '바다' },
  ]

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '32px 20px 80px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ font: '700 22px/30px sans-serif', color: ink, margin: '0 0 4px' }}>
          다이빙 가이드
        </h1>
        <p style={{ font: '400 13px/20px sans-serif', color: secondary, margin: '0 0 24px' }}>
          프리다이빙의 모든 것을 한 곳에서 알아보세요.
        </p>

        {/* 카테고리 바로가기 */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8, marginBottom: 32 }}>
          {categories.map(c => (
            <Link
              key={c.href}
              href={c.href}
              style={{
                display: 'block',
                background: card,
                boxShadow: `inset 0 0 0 1px ${border}`,
                borderRadius: 12,
                padding: '14px 8px',
                textAlign: 'center',
                textDecoration: 'none',
              }}
            >
              <p style={{ font: '600 14px/20px sans-serif', color: ink, margin: '0 0 2px' }}>{c.name}</p>
              <p style={{ font: '400 11px/16px sans-serif', color: secondary, margin: 0 }}>
                {c.count}개 가이드
              </p>
            </Link>
          ))}
        </div>

        {/* 전체 가이드 목록 */}
        <p
          style={{
            font: '500 11px/16px sans-serif',
            color: secondary,
            margin: '0 0 8px',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}
        >
          전체 가이드
        </p>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {guides.map((g, i) => (
            <Link
              key={i}
              href={g.href}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '14px 0',
                borderBottom: `1px solid ${border}`,
                textDecoration: 'none',
              }}
            >
              <span style={{ font: '500 14px/22px sans-serif', color: ink }}>{g.title}</span>
              <span
                style={{
                  font: '500 10px/14px sans-serif',
                  color: accent,
                  background: accentBg,
                  padding: '2px 8px',
                  borderRadius: 999,
                  flexShrink: 0,
                  marginLeft: 12,
                }}
              >
                {g.category}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
